var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-page-not-found',{staticClass:"va-page-not-found-simple"},[_c('s1-icon',{attrs:{"slot":"image","tamanho":"150x150"},slot:"image"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }